import axios from "axios";
import instance from "../../../axios";
// import { NotificationManager } from "react-notifications";
// import Axios from 'axios'

export const LOGIN_URL = `${process.env.REACT_APP_API_URL}/auth/signin`;
export const REGISTER_URL = `${process.env.REACT_APP_API_URL}api/auth/register`;
export const REQUEST_PASSWORD_URL = `${process.env.REACT_APP_API_URL}api/auth/forgot-password`;
export const ME_URL = `${process.env.REACT_APP_API_URL}/auth/me`;
export const LOGIN_URLL = `${process.env.REACT_APP_API_URL}`;
// export function login(email, password) {  
  
//   console.log('data::12', LOGIN_URL, JSON.stringify(data))
//   // const response= Axios(LOGIN_URL, data);
//   axios.post('https://console.gamerji.tech/leagueopsv2api/api/auth/signin', data)
//   .then(response => { 
//     console.log('data::22', response)
//   })
//   .catch(error => {
//     console.log('data::223', error.response)
//   });

  
//   // axios.post(LOGIN_URL, JSON.stringify(data)).then((response) => {
//   //   
//   // });
  
//   // return data;
// }

// export const login = (data) => {

  
//   return instance.post(`${process.env.REACT_APP_API_URL}/auth/signin`, data)
//       .then(res => {
//           return res;
//       })
// }
export const login = (data) => {
  let url = `${process.env.REACT_APP_API_URL}/auth/signin`;

  // Choose the correct URL and send the request
  return instance.post(url, data)
    .then(res => {
      return res;
    }).catch((error) => {
         return error?.response?.data;
    });
}


export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  // return axios.post(REQUEST_PASSWORD_URL, { email });
  return instance.post(`${process.env.REACT_APP_API_URL}/adminuser/forgot`, { email })
      .then(res => {
          return res;
      })
}

export function getUserByToken() {
  return JSON.parse(localStorage.getItem("userData"));
  // Authorization head should be fulfilled in interceptor.
  // return axios.get(ME_URL);
}
